/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import {
  CLEAR_GRANT_VIEW_ACCESS_ADD_USER_AUTH,
  RECEIVED_GRANT_VIEW_ACCESS_ADD_USER_AUTH,
  RECEIVED_VIEW_RELATIONSHIPS,
  SET_ACTIVE_EDIT_CUSTOMER,
  RESET_VIEW_ACCESS_SELECTIONS,
  SET_VIEW_ACCESS_SELECTION,
  RECEIVED_UPDATE_VIEW_RELATIONSHIPS,
  ERROR_GRANT_VIEW_ACCESS_ADD_USER_AUTH
} from 'state/grantViewAccess/GrantViewAccessActions';

const addUserAuthorizationInitialState = {
  granteeBusinessPartyId: null,
  authorized: false,
  requested: false,
  accounts: [],
  gvaEnabledAlready: false
};

export const grantViewAccessInitialState = {
  granteeBusinessPartyId: null,
  addUserAuthorization: addUserAuthorizationInitialState,
  selections: {},
  activeCustomerIndex: null // this is on purpose, null indicates no user is currently selected
};
export const grantViewAccessReducer = (
  state = grantViewAccessInitialState,
  action
) => {
  if (action.type === RECEIVED_GRANT_VIEW_ACCESS_ADD_USER_AUTH) {
    return {
      ...state,
      addUserAuthorization: {
        ...state.addUserAuthorization,
        accounts: action.accounts.accountDescriptors && action.accounts.accountDescriptors.length > 0 ? action.accounts.accountDescriptors : [],
        requested: true,
        gvaEnabledAlready: action.accounts.gvaEnabledAlready
      }
    };
  } else if (action.type === CLEAR_GRANT_VIEW_ACCESS_ADD_USER_AUTH) {
    return {
      ...state,
      addUserAuthorization: addUserAuthorizationInitialState
    };
  } else if (action.type === RECEIVED_VIEW_RELATIONSHIPS) {
    return {
      ...state,
      viewRelationships: action.viewRelationships
    };
  } else if (action.type === RESET_VIEW_ACCESS_SELECTIONS) {
    return {
      ...state,
      selections: {}
    };
  } else if (action.type === SET_VIEW_ACCESS_SELECTION) {
    return {
      ...state,
      selections: {
        ...state.selections,
        ...action.selection
      }
    };
  } else if (action.type === SET_ACTIVE_EDIT_CUSTOMER) {
    return {
      ...state,
      activeCustomerIndex: action.customerIndex
    };
  } else if (action.type === RECEIVED_UPDATE_VIEW_RELATIONSHIPS) {
    return {
      ...state,
      activeCustomerIndex: null,
      selections: {}
    };
  } else if (action.type === ERROR_GRANT_VIEW_ACCESS_ADD_USER_AUTH) {
    return {
      ...state,
      error: action?.error?.errorcode
    };
  }

  return state;
};
